import { useContainerSize } from '@bimser/core';
import IconBreadCrumbArrow from '@bimser/icons/16/breadcrumps-arrow';
import IconClosePanel from '@bimser/icons/16/close-panel';
import * as React from 'react';
import Styles from '../assets/style.scss';
import { IPaginationItemProps } from '../entities';
import classNames from 'classnames/bind';
const cx = classNames.bind(Styles);

const PaginationItem = (props: IPaginationItemProps) => {
	const targetRef = React.useRef<HTMLLIElement>();
	const dimensions = useContainerSize(targetRef);

	React.useEffect(() => {
		props.onSize({ width: dimensions.width, height: dimensions.height });
	}, [dimensions.width, dimensions.height]);

	const onMouseDown = React.useCallback((event: any) => {
		if (event.nativeEvent.which === 3) {
			event.preventDefault();
			event.persist();
			event.stopPropagation();
			if (props.data.onRightClick) {
				props.data.onRightClick(event, props.data);
			}
		}
	}, []);

	const iconOnClick = (e: any) => props.data?.onClickCloseIcon?.(e, props.data);

	const noOp = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const { isActive, isOnTheScreen, isPinned, title, onClick, hasCloseIcon } = props.data;

	const classNames = cx({
		paginationItem: true,
		isActive,
		isOnTheScreen,
		isPinned,
		hasCloseIcon: hasCloseIcon
	});

	const globalClasses = ['paginationItem'];
	if (isActive) {
		globalClasses.push('isActive');
	}

	const onItemClick = React.useCallback((senderArgs: any) => onClick(senderArgs, props.data), []);

	return (
		<li
			className={[classNames, globalClasses.join(' ')].join(' ')}
			ref={targetRef}
		>
			<span
				onContextMenu={noOp}
				className="paginationItemSpan"
				onClick={onItemClick}
				title={title}
				onMouseDown={onMouseDown}
			>
				{title}
			</span>
			<i className={Styles.arrow}>
				<IconBreadCrumbArrow />
			</i>
			{hasCloseIcon && (
				<IconClosePanel
					className={cx({ closeIcon: true })}
					onClick={iconOnClick}
				/>
			)}
		</li>
	);
};

export default PaginationItem;
